import { createRouter, createWebHistory } from 'vue-router'
import { hasRole, isAuthenticated, runtimeConfig } from '@ck/auth'
import HomeView from './views/HomeView.vue'
import LoginView from './views/LoginView.vue'
import VeiculosView from './views/VeiculosView.vue'
import OrdensView from './views/OrdensView.vue'
import OrdemDetalheView from './views/OrdemDetalheView.vue'
import EquipeView from './views/EquipeView.vue'
import RelatoriosView from './views/RelatoriosView.vue'
import MinhaContaView from './views/MinhaContaView.vue'
import ClientesView from './views/ClientesView.vue'
import ClienteDetalheView from './views/ClienteDetalheView.vue'
import PagamentosView from './views/PagamentosView.vue'
import EstoqueView from './views/EstoqueView.vue'

const operationalRoles = ['admin', 'manager', 'technician']

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/auth/callback', redirect: '/' },
    { path: '/', name: 'home', component: HomeView },
    { path: '/veiculos', name: 'veiculos', component: VeiculosView, meta: { roles: operationalRoles } },
    { path: '/ordens', name: 'ordens', component: OrdensView, meta: { roles: operationalRoles } },
    { path: '/ordens/:id', name: 'ordem-detalhe', component: OrdemDetalheView, props: true, meta: { roles: operationalRoles } },
    { path: '/clientes', name: 'clientes', component: ClientesView, meta: { roles: operationalRoles } },
    { path: '/clientes/:id', name: 'cliente-detalhe', component: ClienteDetalheView, props: true, meta: { roles: operationalRoles } },
    { path: '/pagamentos', name: 'pagamentos', component: PagamentosView, meta: { roles: ['admin', 'manager'] } },
    { path: '/estoque', name: 'estoque', component: EstoqueView, meta: { roles: ['admin', 'manager'] } },
    { path: '/equipe', name: 'equipe', component: EquipeView, meta: { roles: ['admin', 'manager'] } },
    { path: '/relatorios', name: 'relatorios', component: RelatoriosView, meta: { roles: ['admin', 'manager'] } },
    { path: '/minha-conta', name: 'minha-conta', component: MinhaContaView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

router.beforeEach((to) => {
  const authenticated = isAuthenticated()
  if (!to.meta.public && !authenticated) return { name: 'login' }
  if (to.name === 'login' && authenticated && runtimeConfig.authRequired) return { name: 'home' }

  const roles = to.meta.roles as string[] | undefined
  if (roles && !roles.some((role) => hasRole(role))) return { name: 'home' }

  return true
})

export default router
